import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader mx-auto is-size-1"
}
const _hoisted_2 = {
  key: 1,
  class: "notification is-warning"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "No dataset available.", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" You can create one from the ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" corpus details page ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" . ")
const _hoisted_7 = { class: "field is-horizontal" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "field-label is-normal" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Dataset")
], -1)
const _hoisted_9 = { class: "field-body" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "control" }
const _hoisted_12 = { class: "select is-fullwidth" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: "",
  disabled: ""
}, "—", -1)
const _hoisted_15 = ["value", "title"]
const _hoisted_16 = { class: "field is-horizontal" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "field-label is-normal" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Set")
], -1)
const _hoisted_18 = { class: "field-body" }
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "control" }
const _hoisted_21 = { class: "select is-fullwidth" }
const _hoisted_22 = ["disabled", "title"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: "",
  disabled: ""
}, "—", -1)
const _hoisted_24 = ["value"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["disabled", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _ctx.updateModelValue,
    title: _ctx.truncateLong(_ctx.title)
  }, {
    footer: _withCtx(({ close }) => [
      _createElementVNode("button", {
        class: "button ml-auto",
        onClick: close
      }, "Cancel", 8, _hoisted_25),
      _createElementVNode("button", {
        class: _normalizeClass(["button is-info", { 'is-loading': _ctx.loading }]),
        type: "submit",
        disabled: !_ctx.canAdd,
        title: _ctx.canAdd ? 'Add selected elements to the dataset' : 'Please select a dataset and related set',
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addToSelection && _ctx.addToSelection(...args)))
      }, " Add elements ", 10, _hoisted_26)
    ]),
    default: _withCtx(() => [
      (_ctx.availableDatasets === null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : (_ctx.availableDatasets?.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("p", null, [
                _hoisted_4,
                _createVNode(_component_router_link, {
                  to: { name: 'corpus-update', params: { corpusId: _ctx.corpusId } },
                  class: "has-text-weight-semibold"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["to"]),
                _hoisted_6
              ])
            ]))
          : (_openBlock(), _createElementBlock("form", {
              key: 2,
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addToSelection && _ctx.addToSelection(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDataset) = $event)),
                          disabled: _ctx.loading ?? null
                        }, [
                          _hoisted_14,
                          (_ctx.availableDatasets)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.availableDatasets, (dataset) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: dataset,
                                  key: dataset.id,
                                  title: dataset.description
                                }, _toDisplayString(_ctx.truncateLong(dataset.name)), 9, _hoisted_15))
                              }), 128))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_13), [
                          [_vModelSelect, _ctx.selectedDataset]
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSet) = $event)),
                          disabled: (!_ctx.selectedDataset || _ctx.loading) ?? null,
                          title: _ctx.selectedDataset ? `Set elements will be added to on dataset ${_ctx.selectedDataset.name}` : 'Please select a dataset first' 
                        }, [
                          _hoisted_23,
                          (_ctx.selectedDataset?.sets)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.selectedDataset.sets, (value) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: value,
                                  key: value.id
                                }, _toDisplayString(value.name), 9, _hoisted_24))
                              }), 128))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_22), [
                          [_vModelSelect, _ctx.selectedSet]
                        ])
                      ])
                    ]),
                    (_ctx.fieldErrors.set_id)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.fieldErrors.set_id, (err) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: err,
                            class: "help is-danger"
                          }, _toDisplayString(err), 1))
                        }), 128))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 32))
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue", "title"]))
}